import script from "./MessageGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageGroups.vue?vue&type=script&setup=true&lang=js"

import "./MessageGroups.vue?vue&type=style&index=0&id=4af71735&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af71735"]])

export default __exports__